import { render, staticRenderFns } from "./TableCell.vue?vue&type=template&id=36048436&"
import script from "./TableCell.vue?vue&type=script&lang=ts&"
export * from "./TableCell.vue?vue&type=script&lang=ts&"
import style0 from "./TableCell.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports